// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__+c+0X","formControl":"addForm_formControl__ISPLH","list":"addForm_list__YV5H2","btnWrpper":"addForm_btnWrpper__BYqxa"};